import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserServiceApi {

  constructor(private http: HttpClient) { }

    getUsers() {
        return this.http.get(`${environment.apiUrl}/common/user`, {
            headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
        })
    }

    getUser(id:any) {
      return this.http.get(`${environment.apiUrl}/common/user/get/${id}`, {
          headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
      }).toPromise();
  }

}
